import { lazily } from '@mk/core'
import { ContentLayout } from '@/features/layout/ContentLayout'

const { ContactMgmt, ProductMgmt } = lazily(() => import('@/features/web'))

/**
 * 系统基础路由
 */
export default [
  {
    id: Symbol('web'),
    path: '/web',
    element: <ContentLayout />,
    children: [
      {
        id: Symbol('web-contact'),
        path: 'contact',
        handle: {
          code: 'web-contact'
        },
        element: <ContactMgmt />
      },
      {
        id: Symbol('web-product'),
        path: 'product',
        handle: {
          code: 'web-product'
        },
        element: <ProductMgmt />
      }
    ]
  }
]
